/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { _ as _toConsumableArray } from '../_chunks/dep-be6b014c.mjs';
import { defineComponent, computed, createVNode, Fragment } from 'vue';
import { d as dayjs } from '../_chunks/dep-0927ceb7.mjs';
import { useCommonClassName } from '../hooks/useConfig.mjs';
import { useContent } from '../hooks/tnode.mjs';
import './hook/index.mjs';
import { useCalendarCellClass } from './hook/useCalendarClass.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-558fadc3.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import './hook/useState.mjs';
import './const.mjs';
import './utils.mjs';
import './hook/useController.mjs';
import '../_chunks/dep-44e322cb.mjs';
import './hook/useColHeaders.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var clickTypeEmitEventMap = {
  click: "click",
  dblclick: "dblclick",
  contextmenu: "rightclick"
};
var CalendarCellItem = defineComponent({
  name: "TCalendarCell",
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      "default": function _default() {
        return null;
      }
    },
    fillWithZero: {
      type: Boolean,
      "default": void 0
    },
    theme: {
      type: String,
      "default": function _default() {
        return null;
      }
    },
    t: Function,
    global: Object,
    cell: [String, Function],
    cellAppend: [String, Function]
  },
  emits: _toConsumableArray(Object.values(clickTypeEmitEventMap)),
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var renderContent = useContent();
    var cls = useCalendarCellClass();
    var _useCommonClassName = useCommonClassName(),
      STATUS = _useCommonClassName.STATUS;
    var valueDisplay = computed(function () {
      if (props.item.mode === "month") {
        var _ref2, _props$fillWithZero;
        var dateNum = props.item.date.getDate();
        var fillZero = dateNum < 10 && ((_ref2 = (_props$fillWithZero = props.fillWithZero) !== null && _props$fillWithZero !== void 0 ? _props$fillWithZero : props.global.fillWithZero) !== null && _ref2 !== void 0 ? _ref2 : true);
        return fillZero ? "0".concat(dateNum) : dateNum;
      }
      var map = props.t(props.global.cellMonth).split(",");
      return map[props.item.date.getMonth().toString()];
    });
    var allowSlot = computed(function () {
      return props.theme === "full";
    });
    var disabled = computed(function () {
      return props.item.mode === "month" && props.item.belongTo !== 0;
    });
    var cellCls = computed(function () {
      var _ref3;
      var _props$item = props.item,
        mode = _props$item.mode,
        date = _props$item.date,
        formattedDate = _props$item.formattedDate,
        isCurrent = _props$item.isCurrent;
      var now = new Date();
      var isNow = mode === "year" ? now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear() : formattedDate === dayjs().format("YYYY-MM-DD");
      return [cls.tableBodyCell.value, (_ref3 = {}, _defineProperty(_ref3, STATUS.value.disabled, disabled.value), _defineProperty(_ref3, STATUS.value.checked, isCurrent), _defineProperty(_ref3, cls.tableBodyCell4Now.value, isNow), _ref3)];
    });
    var clickCell = function clickCell(e) {
      if (disabled.value) return;
      var emitName = clickTypeEmitEventMap[e.type];
      emit(emitName, e);
    };
    var renderDefaultNode = function renderDefaultNode() {
      return createVNode(Fragment, null, [createVNode("div", {
        "class": cls.tableBodyCellDisplay.value
      }, [valueDisplay.value]), createVNode("div", {
        "class": cls.tableBodyCellCsontent.value
      }, [allowSlot.value && renderContent("cellAppend", void 0, {
        params: _objectSpread({}, props.item)
      })])]);
    };
    return function () {
      return props.item && createVNode("td", {
        "class": cellCls.value,
        "onClick": clickCell,
        "ondblclick": clickCell,
        "oncontextmenu": clickCell
      }, [renderContent("cell", void 0, {
        defaultNode: renderDefaultNode(),
        params: _objectSpread({}, props.item)
      })]);
    };
  }
});

export { CalendarCellItem as default };
//# sourceMappingURL=calendar-cell.mjs.map
